export default __webpack_public_path__ + "static/media/wedding.0d8a21fd.jpg";